// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedRulersTearMeniscusMeasurement_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1 0V24H9V22H3V19H7V17H3V13H8V11H3V7H7V5H3V2H9V0H1Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M14.1983 10.832C13.4259 12.3992 13 13.7631 13 14.7496C13 17.1558 14.8668 19 17 19C19.1393 19 21 17.1794 21 14.7496C21 13.7631 20.5741 12.3992 19.8017 10.832C19.0533 9.31362 18.0854 7.81236 17.2373 6.61222C17.1568 6.49825 17.0776 6.38734 17 6.27977C16.9224 6.38734 16.8432 6.49824 16.7627 6.61221C15.9146 7.81236 14.9467 9.31362 14.1983 10.832ZM15.7383 4.61695C15.5478 4.87383 15.3431 5.1556 15.1294 5.45799C13.3686 7.94968 11 11.8418 11 14.7496C11 18.1753 13.6791 21 17 21C20.3209 21 23 18.2053 23 14.7496C23 11.8418 20.6314 7.94968 18.8706 5.45799C18.6569 5.1556 18.4522 4.87383 18.2617 4.61696C17.5237 3.62164 17 3 17 3C17 3 16.4763 3.62164 15.7383 4.61695Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedRulersTearMeniscusMeasurement is a generated icon component.
 */
let IconMedRulersTearMeniscusMeasurement = IconMedRulersTearMeniscusMeasurement_1 = class IconMedRulersTearMeniscusMeasurement extends IconBaseElement {
    render() {
        return html `${IconMedRulersTearMeniscusMeasurement_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedRulersTearMeniscusMeasurement.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedRulersTearMeniscusMeasurement = IconMedRulersTearMeniscusMeasurement_1 = __decorate([
    customElement('zui-icon-med-rulers-tear-meniscus-measurement')
], IconMedRulersTearMeniscusMeasurement);
export { IconMedRulersTearMeniscusMeasurement };
